export const comments_3294065 = {"data":{"data":[],"links":{}}}